<template>
    <span>
        <router-link
            to="/tickets/alerts"
        >
            <v-badge
                v-if="ticketAlertsEnabledForCompany"
                id="alert-badge"
                :color="ticketAlerts.length ? '#F26227' : invisible"
                overlap
                offset-x="24"
                offset-y="24"
                :content="ticketAlerts.length"
            >
                <v-btn icon>
                    <v-icon class="material-icons-outlined">
                        notifications
                    </v-icon>
                </v-btn>
            </v-badge>
        </router-link>
    </span>    
</template>

<script>
export default {
    name: 'TicketAlertsControl',
    data() {
        return {
            invisible: 'rbga(0,0,0,0)',
        };
    },
    computed: {
        ticketAlertsEnabledForCompany() {
            const companyPermissions = this.$store.getters.companyPermissions;
            return companyPermissions.some((element) => {
                return element.permission === 'TICKET_ALERTS' && element.granted == 1;
            });
        },
        ticketAlerts() {
            return this.$store.getters.ticketAlerts;
        },
    },
};
</script>
